<template>
<div class="form-footer">
  <slot name="cancel-btn"></slot>
  <button class="btn btn-primary btn-lg submit-btn" id="formValidationButton" type="submit">
    <slot name="validation-btn-text">Suivant <i class="bi bi-arrow-right-circle"></i></slot>
  </button>
</div>
</template>